var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManatSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368 272V456C368 469.25 357.25 480 344 480S320 469.25 320 456V272C320 237.188 306.266 204.625 281.312 180.312C263.002 162.471 240.527 150.986 216 146.391V456C216 469.25 205.25 480 192 480S168 469.25 168 456V146.619C108.336 157.789 64 209.186 64 272V456C64 469.25 53.25 480 40 480S16 469.25 16 456V272C16 182.535 81.49 110.217 168 98.471V56C168 42.75 178.75 32 192 32S216 42.75 216 56V98.148C253.168 103.168 287.43 119.281 314.797 145.938C349.109 179.344 368 224.125 368 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManatSign);
export default __webpack_public_path__ + "static/media/manat-sign.845bf0c5f1a401ba189cdbf70bb6fdf6.svg";
export { ForwardRef as ReactComponent };